export default __webpack_public_path__ + "static/media/62.6efb9989.png";